var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1335_1122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.65 0.609375H3.41406C1.89062 0.609375 0.671875 1.82812 0.671875 3.35156V35.6484C0.671875 37.1109 1.89062 38.3906 3.41406 38.3906H35.5281C37.0516 38.3906 38.2703 37.1719 38.2703 35.6484V3.29063C38.3922 1.82812 37.1735 0.609375 35.65 0.609375ZM11.8235 32.7234H6.27815V14.7469H11.8235V32.7234ZM9.02034 12.2484C7.19221 12.2484 5.79062 10.7859 5.79062 9.01875C5.79062 7.25156 7.25315 5.78906 9.02034 5.78906C10.7875 5.78906 12.25 7.25156 12.25 9.01875C12.25 10.7859 10.9094 12.2484 9.02034 12.2484ZM32.8469 32.7234H27.3016V24.0094C27.3016 21.9375 27.2406 19.1953 24.3766 19.1953C21.4516 19.1953 21.025 21.5109 21.025 23.8266V32.7234H15.4797V14.7469H20.9031V17.2453H20.9641C21.7563 15.7828 23.5235 14.3203 26.2656 14.3203C31.9328 14.3203 32.9688 17.9766 32.9688 22.9734V32.7234H32.8469Z",
    fill: "#0077B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1335_1122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.20267f2a28b32b99ce971713404a7980.svg";
export { ForwardRef as ReactComponent };